var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExitwindow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    focusable: "false",
    className: "chakra-icon css-kgoxx1",
    "aria-label": "store-discount",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero",
    stroke: "currentColor",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M21 20.0001L16 19.9999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.78 20V9.98706"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 16.9739V15.046C4 14.5034 4.21557 13.9829 4.59928 13.5992C4.98299 13.2155 5.50341 13 6.04605 13H7.97353C8.51614 13 9.03653 13.2155 9.42023 13.5992L12.4007 16.5793C13.1997 17.3782 13.1998 18.6736 12.4009 19.4727L10.4735 21.4006C10.0898 21.7843 9.56937 22 9.0267 22C8.48403 22 7.96358 21.7845 7.57983 21.4008L4.59935 18.4207C4.21559 18.037 4 17.5165 4 16.9739Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.96469 15.9646C6.98423 15.9451 7.01587 15.9451 7.03538 15.9647C7.05488 15.9842 7.05487 16.0158 7.03536 16.0354C7.01584 16.0549 6.9842 16.0549 6.96467 16.0354C6.94514 16.0159 6.94511 15.9842 6.9646 15.9647L6.96469 15.9646"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.27578 6.47765C1.98065 7.03345 1.92197 7.68473 2.113 8.28433C2.44346 9.32453 3.41962 10.0228 4.5108 9.99943C5.60198 9.9761 6.5474 9.23678 6.8331 8.18341C6.85121 8.12223 6.90742 8.08025 6.97122 8.08025C7.03503 8.08025 7.09124 8.12223 7.10935 8.18341C7.40109 9.25558 8.37468 9.99958 9.48584 9.99946C10.597 9.99934 11.5704 9.25514 11.8619 8.1829C11.88 8.12169 11.9362 8.07968 12 8.07968C12.0639 8.07968 12.1201 8.12169 12.1381 8.1829C12.4298 9.2551 13.4034 9.99918 14.5145 9.99914C15.6257 9.9991 16.5992 9.25495 16.8908 8.18273C16.9089 8.12156 16.9651 8.0796 17.0289 8.0796C17.0927 8.0796 17.1489 8.12156 17.167 8.18273C17.4528 9.23599 18.3981 9.97521 19.4892 9.99858C20.5803 10.0219 21.5564 9.32387 21.887 8.28381C22.0781 7.68412 22.0194 7.0327 21.7242 6.47681L20.0175 3.09822C19.6773 2.4247 18.9869 2 18.2324 2H5.76809C5.01351 2 4.32316 2.4247 3.98293 3.09822L2.27578 6.47765Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExitwindow);
export default __webpack_public_path__ + "static/media/exitwindow.31192e0a02c851fca190760564939c4d.svg";
export { ForwardRef as ReactComponent };